<template>
  <div class="background">
    <div class="page-shell">
      <header class="page-header">
        <div class="logo mr-4">
          <app-logo/>
        </div>
        <div class="page-title">
          Bem vindo a área de {{ descEvento("titulo") }}
        </div>
      </header>

      <v-fade-transition>
        <v-progress-linear v-if="loading" color="#efc00f" indeterminate height="3px"/>
      </v-fade-transition>

      <main class="page-main">
        <section v-if="!existeEventoEdicaoativa" class="section section--notice">
          <v-icon color="info" small>mdi-information-slab-box</v-icon>
          Olá, no momento não temos nenhum(a) <strong>{{descEvento("titulo")}}</strong> com inscrições abertas.
          Fique ligado que em breve abriremos novos eventos.
        </section>

        <template v-else>
          <section class="section section--intro">
            Para efetuar sua inscrição <strong>{{descEvento("subtitulo")}}</strong>, é necessário que o Fornecedor/Comprador esteja cadastrado em nosso sistema.
          </section>

          <section class="section section--block">
            <div class="section-title-row">
              <div class="d-flex align-center">
                <v-icon color="#167ABC" class="mr-2">mdi-account</v-icon>
                <strong style="color:#167ABC">PASSO 1 - Autenticação/Cadastro</strong>
              </div>
              <div class="d-flex align-center gap-0" style="gap: 12px;">
                <span style="color:#167ABC; font-weight: 500; font-size: 0.9rem; display: flex; align-items: center;">Identificação da Conta:</span>
                <v-radio-group v-model="tipoContaSelecionadoProxy" row dense class="mt-0 radio-group-alinhado" :disabled="autenticacao.encontrou === 1" style="display: inline-flex; align-items: center;">
                  <v-radio color="#efc00f" value="fornecedor">
                    <template v-slot:label>
                      <span style="color:#167ABC; font-size: 0.9rem;">Fornecedor</span>
                    </template>
                  </v-radio>
                  <v-radio color="#efc00f" value="comprador">
                    <template v-slot:label>
                      <span style="color:#167ABC; font-size: 0.9rem;">Comprador</span>
                    </template>
                  </v-radio>
                </v-radio-group>
              </div>
            </div>

            <v-divider class="my-2"/>
            <v-row v-if="autenticacao.encontrou===0 || autenticacao.encontrou ===2">
              <v-col cols="12">
                <AutenticacaoForm
                  :autenticacao="autenticacao"
                  :tipoContaSelecionado="tipoContaSelecionadoProxy"
                  @onLogin="handleLogin"
                />
              </v-col>
            </v-row>
            <v-row v-else-if="autenticacao.encontrou===3" class="mt-0">
              <v-col cols="12" class="py-2">
                <v-icon color="red" small>mdi-alert</v-icon><strong>Confira seus Dados.</strong>
                Mais de um responsável encontrado com os dados informados.<br>
                <strong>Entre em contato com a administração do SEBRAE!</strong>
              </v-col>
            </v-row>
            <div v-else class="mt-0">
              <v-alert dense text color="success" border="left" class="mb-3 mt-1">
                <div class="d-flex align-center justify-space-between flex-wrap" style="gap: 8px;">
                  <div class="d-flex align-center">
                    <v-icon color="success" class="mr-2">mdi-check-circle</v-icon>
                    <span>
                      <strong>Autenticado com sucesso!</strong>
                      Confira seus dados abaixo. Se houver alguma inconsistência, entre em contato com o SEBRAE.
                    </span>
                  </div>
                  <v-btn
                    color="warning"
                    small
                    @click="sairComecarOutro"
                    :disabled="loading">
                    Sair
                  </v-btn>
                </div>
              </v-alert>
              <v-row dense>
                <v-col cols="12" sm="3">
                  <div class="dado-label">{{ autenticacao.dadosLogado.current.descNivel }}</div>
                  <div class="dado-valor">{{ autenticacao.dadosLogado.current.nome }}</div>
                </v-col>
                <v-col cols="12" sm="3">
                  <div class="dado-label">{{ labelDocumentoEmpresa }}</div>
                  <div class="dado-valor">{{ autenticacao.dadosLogado.current.cnpj }}</div>
                </v-col>
                <v-col cols="12" sm="3">
                  <div class="dado-label">Responsável</div>
                  <div class="dado-valor">{{ autenticacao.dadosLogado.current.nomeResponsavel }}</div>
                </v-col>
                <v-col cols="12" sm="3">
                  <div class="dado-label">Status</div>
                  <div class="dado-valor">{{ autenticacao.dadosLogado.current.descStatus }}</div>
                </v-col>
              </v-row>
              <v-row dense v-show="autenticacao.dadosLogado.current.status !== 'A'">
                <v-col cols="12">
                  <v-alert dense text color="warning" class="mb-3 mt-1">
                    <div class="d-flex align-center">
                      <v-icon color="warning" class="mr-2">mdi-alert</v-icon>
                      <span>
                        O status da sua conta é <b>"{{ autenticacao.dadosLogado.current.descStatus }}"</b>, o que indica que a você poderá se inscrever, mas ainda depende da aprovação do seu cadastro por parte do SEBRAE.
                      </span>
                    </div>
                  </v-alert>
                </v-col>
              </v-row>
            </div>
          </section>

          <section class="section section--block mt-4">
            <div class="d-flex align-center mb-3">
              <v-icon color="#167ABC" class="mr-2">mdi-calendar-check-outline</v-icon>
              <strong style="color:#167ABC">PASSO 2 - Efetivar Inscrição</strong>
            </div>
            <v-divider class="my-2"/>
            <v-fade-transition>
              <v-progress-linear v-if="loadingBuscaInscricao" color="#efc00f" indeterminate height="3px" class="mb-3"/>
            </v-fade-transition>
            <v-row class="mt-0">
              <v-col cols="12" class="py-2">
                <span class="text-caption">
                  <v-icon color="green" small>mdi-information-slab-box</v-icon> {{descEvento('tituloPasso2')}}.
                </span>
              </v-col>
              <v-col cols="12" class="py-2">
                <InscrevaSe2Form ref="eventosDisponiveis"
                  :autenticacao="autenticacao"
                  :idEmpresa="autenticacao.dadosLogado.current && autenticacao.dadosLogado.current.id"
                  :nivel="autenticacao.dadosLogado.current && autenticacao.dadosLogado.current.nivel"
                  :descNivel="autenticacao.dadosLogado.current && autenticacao.dadosLogado.current.descNivel"
                  :autenticado="autenticacao.encontrou === 1"
                />
              </v-col>
            </v-row>
          </section>
        </template>
      </main>

      <footer class="page-footer">
        <v-spacer/>
        <!-- <v-btn color="success" @click="sair" :disabled="loading">Sair da Tela de Eventos</v-btn> -->
        <v-btn color="warning" v-show="autenticacao.encontrou === 1" @click="sairComecarOutro" :disabled="loading">Sair</v-btn>
      </footer>
    </div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular
        indeterminate
        color="primary"
        class="ma-4"
      ></v-progress-circular>
    </v-overlay>    
  </div>
</template>

<script>
import {mapActions} from "vuex";
import AppLogo from "../../components/app/AppLogo";
import InscrevaSeForm from "./components/InscrevaSeForm";
import InscrevaSe2Form from "./components/InscrevaSe2Form";
import AutenticacaoForm from "./components/AutenticacaoForm";
import {findAllEventoEdicaoAtivasPublica} from "../../api/eventoEdicao";
import {ApiError} from "../../api/core";

export default {
  components: {AppLogo, InscrevaSeForm, InscrevaSe2Form, AutenticacaoForm},
  name: "InscrevaSe",
  props: {
    tipoContaSelecionado: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      edicaoAtiva: {},
      existeEventoEdicaoativa: false,
      tipoContaSelecionadoLocal: this.tipoContaSelecionado,
      autenticacao: {
        dadosLogado: {
          token: "",
          current: {}          
        },
        encontrou: 0,
      },
      loading: false,
      loadingBuscaInscricao: false,
    }
  },
  computed: {
    eventoId() {
      const id = this.$route.params.id;
      return id ? parseInt(id) : 0;      
    },
    tipoContaSelecionadoProxy: {
      get() {
        return this.tipoContaSelecionadoLocal;
      },
      set(value) {
        this.tipoContaSelecionadoLocal = value;
      }
    },
    labelDocumentoEmpresa() {
      const dados = this.autenticacao?.dadosLogado?.current || {};
      return ['FOR', 'COM'].includes(dados.nivel) && dados.flgEmpresaEstrangeira === 'S'
        ? 'Registro da empresa estrangeira'
        : 'CNPJ';
    }
  },
  watch: {
    tipoContaSelecionado(newValue) {
      this.tipoContaSelecionadoLocal = newValue;
    }
  },
  methods: {
    ...mapActions('auth', ['doLogout']),
    handleLogin(loginData) {
      this.autenticacao = {
        dadosLogado: {
          token: loginData.token,
          current: loginData.current
        },
        encontrou: loginData.encontrou
      };
    },
    descEvento(localMensagem) {
      let descricao = "";
      if (localMensagem==="titulo"){
        descricao = "Inscrições de Eventos do SEBRAE";
      } else if (localMensagem==="subtitulo"){
        descricao = "nos Eventos do SEBRAE";
      } else if (localMensagem==="tituloPasso2"){
        descricao = "Escolha o evento disponível desejado e clique em \"Quero me inscrever\" correspondente á sua escolha, para efetivar sua inscrição.";
      }
      return descricao;
    },
    async verificaSeTemEdicoesAtivas() {
      try {
        this.loading = true;
        this.edicaoAtiva = await findAllEventoEdicaoAtivasPublica(1, this.eventoId, {});
        if (this.edicaoAtiva.elements.length > 0) this.existeEventoEdicaoativa = true;
      } catch (err) {
        if (err instanceof ApiError) {
          this.$toast.error(err.message, {
            timeout: 6000
          })
        } else {
          this.$toast.error(`Não foi possível verificar se existe Evento ativo!`, {
            timeout: 6000
          })
        }
      } finally {
        this.loading = false;
      }        
    },
    async sairComecarOutro() {
      await this.doLogout();
      this.tipoContaSelecionadoLocal = '';
      this.autenticacao = {
        dadosLogado: {
          token: "",
          current: {}          
        },
        encontrou: 0,
      }
    },
    async sair(){
      await this.doLogout();
      this.$router.push({
        name: 'Login'
      });
    }
  },
  mounted() {
    this.verificaSeTemEdicoesAtivas();
  }
}
</script>

<style scoped lang="scss">
.background {
  position: relative;
  min-height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 1rem;
  background-color: #167ABC;

  .logo {
    padding: 5px;

    img {
      height: 60px;
    }
  }
}

.background::before {
  content: "";
  position: fixed;
  inset: 0;
  background-image: url('../../assets/backgrounds/bg-card-login.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center right;
  z-index: 0;
}

.page-shell {
  position: relative;
  z-index: 1;
  width: min(1280px, 100%);
  min-height: calc(100vh - 2rem);
  display: flex;
  flex-direction: column;
  border-radius: 14px;
  overflow: hidden;
  background: #f7fafc;
  box-shadow: 0 14px 42px rgba(8, 34, 60, 0.22);
}

.page-header {
  min-height: 84px;
  background: #167ABC;
  color: #ffffff;
  display: flex;
  align-items: center;
  padding: 0 1.25rem;
}

.page-title {
  flex-grow: 1;
  font-size: 1.08rem;
  font-weight: 600;
}

.page-main {
  flex: 1;
  overflow: auto;
  padding: 1rem 1.25rem;
}

.section {
  background: #ffffff;
  color: #2a3744;
  border: 1px solid #e4edf5;
  border-radius: 12px;
  padding: 1rem 1.2rem;
}

.section + .section {
  margin-top: 1rem;
}

.section--notice {
  color: #35516a;
}

.section--intro {
  background: #f2f8fd;
  border-color: #d5e7f6;
  font-size: 0.9rem;
}

.section-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.8rem;
  flex-wrap: wrap;
}

.page-footer {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.85rem 1.25rem;
  border-top: 1px solid #dde8f1;
  background: #ffffff;
}

@media (max-width: 960px) {
  .background {
    padding: 0;
  }

  .page-shell {
    min-height: 100vh;
    border-radius: 0;
  }

  .page-header,
  .page-main,
  .page-footer {
    padding-left: 0.8rem;
    padding-right: 0.8rem;
  }
}

.radio-group-alinhado {
  margin-bottom: 0 !important;
}

.radio-group-alinhado ::v-deep .v-input__control {
  margin-bottom: 0 !important;
  min-height: auto !important;
}

.radio-group-alinhado ::v-deep .v-input__slot {
  margin-bottom: 0 !important;
  padding-bottom: 0 !important;
}

.radio-group-alinhado ::v-deep .v-input__details {
  display: none !important;
}

.dado-label {
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: uppercase;
  color: #888;
  letter-spacing: 0.04em;
  margin-bottom: 2px;
}

.dado-valor {
  font-size: 0.9rem;
  color: #222;
  font-weight: 500;
}
</style>